import { useDispatch } from 'react-redux';

import {
  setFeatureFlags,
  getAmplitudeFeatureFlags,
} from 'store/actions/featureFlag';
import { isOnPremURL } from 'utils/brandUrl';

function useFeatureFlag() {
  const dispatch = useDispatch();

  function fetchFeatureFlags({ userId, auth, orgId }) {
    if (isOnPremURL()) {
      dispatch(setFeatureFlags({ userId, auth, orgId }));
    } else {
      dispatch(getAmplitudeFeatureFlags({ userId, auth, orgId })).finally(
        () => {
          dispatch(setFeatureFlags({ userId, auth, orgId }));
        }
      );
    }
  }

  return { fetchFeatureFlags };
}

export default useFeatureFlag;
